import { QueryClient } from "@tanstack/react-query";

// 创建QueryClient实例
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 默认查询选项
      staleTime: 5 * 60 * 1000, // 5分钟
      gcTime: 10 * 60 * 1000, // 10分钟
      retry: (failureCount, error: any) => {
        // 对于网络错误或5xx错误重试，其他错误不重试
        if (
          error?.code === "NETWORK_ERROR" ||
          (error?.status >= 500 && error?.status < 600)
        ) {
          return failureCount < 3;
        }
        return false;
      },
      refetchOnWindowFocus: false, // 窗口聚焦时不重新获取
      refetchOnReconnect: true, // 网络重连时重新获取
      refetchOnMount: true, // 组件挂载时重新获取
    },
    mutations: {
      // 默认变更选项
      retry: 1, // 变更操作只重试一次
      onError: (error) => {
        console.error("Mutation错误:", error);
      },
    },
  },
});

// 错误处理中间件
queryClient.setDefaultOptions({
  queries: {
    meta: {
      onError: (error: any) => {
        // 统一的错误处理逻辑
        console.error("Query错误:", error);

        // 可以根据错误类型显示不同的用户提示
        if (error?.status === 401) {
          // 未授权错误，可能需要重新登录
          console.warn("用户未授权，可能需要重新登录");
        } else if (error?.status === 403) {
          // 权限不足错误
          console.warn("用户权限不足");
        } else if (error?.status === 404) {
          // 资源不存在错误
          console.warn("请求的资源不存在");
        }
      },
    },
  },
});
